import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import { LearningIcon } from "../../../assets/svg/LearningIcon";
import Header from "../components/Header";
import Modal from "../../../ui/Modal";
import { Formik, Field } from "formik";
import Input from "../../../ui/Input";
import Form, { InputSection } from "../components/Form";
import { NavLink, useRouteMatch, useLocation } from "react-router-dom";
import { postEndpoint, putEndpoint, GetHook } from "../../../api/api";
import { PERSPECTIVE_URL } from "../../../api/urls";
import Axios from "axios";
import { get } from "../../../utils/get";
import { toast } from "react-toastify";
import { EditDeleteFormatter } from "../../../ui/TableFormatter";
import Swal from "sweetalert2";
import { PerspectiveSchema } from "../../../utils/validationSchema/ScorecardConfigSchema/PerspectiveSchema";
import { is360Subject } from "../../../subjects/Is360Subject";
import {
  sortConfigPerspectives,
  sortPerspectives,
} from "../../../utils/sortPerspectives";
const PerspectiveComponent = () => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [createRes, createReq] = postEndpoint();
  const [updateRes, updateReq] = putEndpoint();
  const [perspectives, setPerspectives] = useState<any>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [id, setId] = useState();
  const [editData, setEditData] = useState([]);
  const { data, reload } = GetHook(PERSPECTIVE_URL);

  const { url } = useRouteMatch();
  const formRef: any = useRef<any>(null);
  const location = useLocation();

  const isAddMode = !id;

  useEffect(() => {
    setPerspectives(data);
    return () => {};
  }, [data]);

  const handleAddPerspective = (values) => {
    createReq(PERSPECTIVE_URL, values);
  };

  useEffect(() => {
    const { complete, pending, data, error } = createRes;
    if (error) toast.error(get(data, "message"));
    if (!pending && complete && !error) {
      setPerspectives([data.returned_resultset[0], ...perspectives]);
      toast.success("Perspecive configured");
      setisModalOpen(false);
    }

    return () => {};
  }, [createRes]);

  const setEdit = (perspective) => {
    setIsEdit(true);
    setId(perspective?.id);
    setEditData(perspective);
    setisModalOpen(true);
  };
  const closeModal = () => {
    setisModalOpen(false);
    setIsEdit(false);
    setId(undefined);
    formRef.current.resetForm(initialValues);
  };

  useEffect(() => {
    if (!isAddMode) {
      const fields = ["name", "notes", "is_360"];

      fields.forEach((field) =>
        formRef.current.setFieldValue(field, editData[field], false)
      );
    }
  }, [isAddMode]);

  const editPerspective = (values) => {
    updateReq(`${PERSPECTIVE_URL}/${id}`, values);
  };
  useEffect(() => {
    const { complete, pending, data } = updateRes;
    if (!pending && complete && data) {
      closeModal();
      toast.success("Perspective updated");
      reload(get(location, "key"));
    }
  }, [setisModalOpen, updateRes]);

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          Axios.delete(`${PERSPECTIVE_URL}/${id}`)
            .then(() => {
              setPerspectives(
                perspectives.filter((perspective: any) => perspective?.id != id)
              );
              toast.success("Perpsective has been deleted");
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  const sortedPerspectives = sortConfigPerspectives(perspectives);
console.log(perspectives);


  const renderAddPerspective = () => {
    return (
      <Form>
        <InputSection>
          <Field
            name="name"
            placeholder="enter perspective name"
            label="Perspective name"
            component={Input}
            isBordered={true}
            width="96%"
          />
        </InputSection>
        <InputSection>
          <Field
            type="textarea"
            name="notes"
            placeholder="Description"
            label="Perspective description"
            component={Input}
          />
        </InputSection>
        <CheckboxContainer>
          <Field name="is_360" type="checkbox" />
          <TitleText>Is 360?</TitleText>
        </CheckboxContainer>
      </Form>
    );
  };
  const initialValues = {
    name: "",
    notes: "",
  };
  return (
    <Formik
      innerRef={formRef}
      initialValues={initialValues}
      validationSchema={PerspectiveSchema}
      onSubmit={isAddMode ? handleAddPerspective : editPerspective}
    >
      {({ handleSubmit }) => (
        <PerspectiveConatiner>
          <Header
            title="Perspectives"
            isEdit={isEdit}
            setisModalOpen={setisModalOpen}
            handleDelete={handleDelete}
          />
          {isModalOpen && (
            <Modal
              title={isEdit ? "Edit Perspective" : "Create Perspective"}
              handleSubmit={handleSubmit}
              closeModal={closeModal}
            >
              {renderAddPerspective()}
            </Modal>
          )}
          <Perspectives>
            {sortedPerspectives &&
              sortedPerspectives.map((perspective: any) => (
                <PerspectiveItem
                  key={perspective?.id}
                  to={`${url}/perspective/${perspective?.id}`}
                >
                  <TitleText style={{ fontSize: "12px" }}>
                    {perspective?.name}
                  </TitleText>
                  <div style={{ display: "flex" }}>
                    <LearningIcon />
                    <span
                      onClick={(e) => {
                        e.preventDefault();
                      }}
                    >
                      <EditDeleteFormatter
                        showEdit={() => setEdit(perspective)}
                        handleDelete={() => handleDelete(perspective?.id)}
                      />
                    </span>
                  </div>
                </PerspectiveItem>
              ))}
          </Perspectives>
        </PerspectiveConatiner>
      )}
    </Formik>
  );
};

export default PerspectiveComponent;

const PerspectiveConatiner = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  border-right: 1px solid rgba(55, 81, 255, 0.1);
`;

const Perspectives = styled.ul`
  display: grid;
  grid-template-rows: repeat(auto-fill, 4.3125em);
  padding: 0;
  margin: 0;
  list-style: none;
`;

const PerspectiveItem = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.4em;
  text-decoration: none;
  &.active {
    background-color: #ebefff;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
